import { createSlice } from '@reduxjs/toolkit';
import login from "../../api/auth/login";

export const createInitialUserState = () => ({
    email: '',
    username: '',
    userId: '',
    roles: [],
    isLoading: false,
    functions: [],
    functionsLoaded: false,
    pathApp: '',
});

export const userSlice = createSlice({
    name: 'user',
    initialState: createInitialUserState(),
    reducers: {
        updateLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        updateUsername: (state, action) => {
            state.username = action.payload
        },
        updateUserId: (state, action) => {
            state.userId = action.payload
        },
        updateFunctions: (state, action) => {
            state.functions = action.payload
            state.functionsLoaded = true
        },
        updatePathApp: (state, action) => {
            state.pathApp = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(login.fulfilled, (state) => {
            state.isLoading = false
        })
        .addCase(login.rejected, (state) => {
            state.isLoading = false
        })
        .addCase(login.pending, (state) => {
            state.isLoading = true
        });
    }
})
export default userSlice.reducer;
export const { updateLoading, updateUsername, updateUserId, updateFunctions, updatePathApp } = userSlice.actions;
